/**
 * Parses a query string into an object.
 * @param {string} query Either a full url or the search portion of a url. If the string doesn't include a '?' an empty object will be returned.
 * @returns {object} Query string "key=value" pairs as { [key]: value }. Values will always be strings.
 */
export default query => {
  if (!query.includes('?')) return {}
  return query
    .replace(/^(.*\?)/, '')
    .split('&')
    .filter(Boolean)
    .reduce((obj, str) => {
      const [key, value] = str.split('=')
      return { ...obj, [key]: value }
    }, {})
}
